import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, rp, fmtDate, statusColor, BOOKING_STATUSES } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { BranchFilter, useBranchFilter } from "@/admin/BranchFilter";

export default function Bookings() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [overdue, setOverdue] = useState(false);
  const { branches, branchId, setBranchId } = useBranchFilter();
  const load = useCallback(() => api.get("/bookings", {
    params: {
      q: q || undefined,
      status: status || undefined,
      overdue: overdue || undefined,
      branch_id: branchId || undefined,
    },
  }).then((r) => setRows(r.data)), [branchId, overdue, q, status]);
  useEffect(() => {
    load();
  }, [load]);
  return (
    <div data-testid="admin-bookings">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h1 className="font-display text-3xl tracking-tight">Bookings</h1>
        <Link to="/admin/bookings/new" data-testid="new-booking-btn" className="lm-btn-primary rounded-md px-4 py-2.5 text-sm font-semibold">+ New Booking</Link>
      </div>
      <div className="mt-5 flex gap-2 flex-wrap">
        <Input data-testid="booking-search" className="max-w-xs" placeholder="Search code, name, WhatsApp" value={q}
          onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} />
        <select data-testid="booking-status-filter" value={status} onChange={(e) => setStatus(e.target.value)}
          className="h-10 rounded-md border border-input bg-white px-3 text-sm">
          <option value="">All statuses</option>
          {BOOKING_STATUSES.map((s) => <option key={s}>{s}</option>)}
        </select>
        <BranchFilter branches={branches} value={branchId} onChange={setBranchId} testid="bookings-branch-filter" />
        <button data-testid="filter-overdue" onClick={() => setOverdue(!overdue)}
          className={`h-10 px-4 rounded-md border text-sm ${overdue ? "bg-lm-red text-white border-lm-red" : "border-black/15"}`}>
          Overdue only
        </button>
        <button onClick={load} className="h-10 px-4 rounded-md border border-black/15 text-sm">Search</button>
      </div>
      <div className="mt-5 overflow-x-auto bg-white border border-black/10 rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-cream-dark text-left text-[11px] uppercase tracking-widest text-ink-soft">
            <tr><th className="p-3">Code</th><th className="p-3">Customer</th><th className="p-3">Date</th><th className="p-3">Package</th>
              <th className="p-3">Qty</th><th className="p-3">Total</th><th className="p-3">Payment</th><th className="p-3">Status</th></tr>
          </thead>
          <tbody className="divide-y divide-black/5">
            {rows.map((b) => (
              <tr key={b.id} className={`hover:bg-cream-dark/40 ${b.is_overdue ? "bg-red-50" : ""}`} data-testid={`booking-row-${b.booking_code}`}>
                <td className="p-3"><Link className="text-lm-red hover:underline" to={`/admin/bookings/${b.id}`}>{b.booking_code}</Link></td>
                <td className="p-3">{b.customer_name}<div className="text-xs text-ink-soft">{b.customer_whatsapp}</div></td>
                <td className="p-3 whitespace-nowrap">{b.rental_date}<div className="text-xs text-ink-soft">{b.start_time}</div></td>
                <td className="p-3">{b.package_name_snapshot}</td>
                <td className="p-3">{b.quantity}</td>
                <td className="p-3 whitespace-nowrap">{rp(b.total_payment)}</td>
                <td className="p-3">{b.payment_status}</td>
                <td className="p-3">
                  <span className={`text-[11px] px-2 py-1 rounded-full border ${statusColor(b.booking_status)}`}>{b.booking_status}</span>
                  {b.is_overdue && <span data-testid={`overdue-${b.booking_code}`} className="ml-1 text-[11px] px-2 py-1 rounded-full bg-lm-red text-white whitespace-nowrap">Overdue</span>}
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={8} className="p-5 text-ink-soft">No bookings.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
